<template>
    <div class="w-full border border-default rounded-lg overflow-hidden text-sm h-fit">
        <table class="w-full border-collapse table-fixed">
            <thead>
                <tr class="border-b border-default">
                    <th class="text-left py-1 px-2 font-semibold w-auto"/>
                    <th class="text-right py-1 px-2 font-semibold w-32">Inngående balanse</th>
                    <th class="text-right py-1 px-2 font-semibold w-32">Åpne poster</th>
                    <th class="text-right py-1 px-2 font-semibold w-32">Differanse</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" :key="row.label" class="border-b border-default last:border-0">
                    <td class="text-left px-2 py-1 font-semibold truncate max-w-0" :title="row.label">
                        {{ row.label }}
                    </td>
                    <td :class="['text-right px-2 py-1 whitespace-nowrap', getIbColor(row)]">
                        {{ row.ib }}
                    </td>
                    <td class="text-right px-2 py-1 text-base-content whitespace-nowrap">
                        {{ row.openPosts }}
                    </td>
                    <td :class="['text-right px-2 py-1 font-medium whitespace-nowrap', getDiffColor(row.diff)]">
                        {{ row.diff }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup lang="ts">
import { formatCurrency } from '@/services/formatter.service'
import { computed } from 'vue'
import useTrialBalance from '@/incoming-balance/tribal.composable'
import subAccountComposable from '@/incoming-balance/subaccount.composable'

const { useCustomerBalance, useSupplierBalance } = subAccountComposable()
const { totalBalance: tbTotal, customerTotal: tbCustomerTotal, supplierTotal: tbSupplierTotal } = useTrialBalance()
const { totalBalance: customerTotal } = useCustomerBalance()
const { totalBalance: supTotal } = useSupplierBalance()

const customerDiff = computed(() => tbCustomerTotal.value - customerTotal.value)
const supplierDiff = computed(() => tbSupplierTotal.value - supTotal.value)

const rows = computed(() => [
    {
        label: 'Kundereskontro',
        ib: formatCurrency(tbCustomerTotal.value),
        openPosts: formatCurrency(customerTotal.value),
        diff: formatCurrency(customerDiff.value)
    },
    {
        label: 'Leverandørreskontro',
        ib: formatCurrency(tbSupplierTotal.value),
        openPosts: formatCurrency(supTotal.value),
        diff: formatCurrency(supplierDiff.value)
    },
    {
        label: 'Sum saldobalanse',
        ib: formatCurrency(tbTotal.value),
        openPosts: null,
        diff: ''
    }
])

const getIbColor = (row: any) => {
    if (row.label === 'Sum saldobalanse' && row.ib !== '0,00') return 'text-error'
    return 'text-base-content'
}

const getDiffColor = (diff: string) => {
    if (!diff || diff === '0,00') return 'text-base-content'
    return 'text-error'
}

</script>